import { Component } from '@angular/core';

@Component({
  selector: 'app-ai-findings-page',
  templateUrl: './ai-findings-page.component.html',
  styleUrls: ['./ai-findings-page.component.scss'],
})
export class AiFindingsPageComponent {
  public findingsSubtitlePath = 'enterpriseAiDetectionPage.tabs.findingsSubtitle';
  public findingsTooltipLabelPath = 'enterpriseAiDetectionPage.tabs.findingsTooltip';
}
